export const ALLINDICES_LIST = "ALLINDICES_LIST";
export const ALLINDICES_LIST_ERROR = "ALLINDICES_LIST_ERROR";
export const ALLINDICES_LIST_HIDE_ERROR = "ALLINDICES_LIST_HIDE_ERROR";
export const ALLINDICES_LIST_START_LOADER = "ALLINDICES_LIST_START_LOADER";
export const ALLINDICES_LIST_STOP_LOADER = "ALLINDICES_LIST_STOP_LOADER";
